<template>
  <pui-side-panel
    :open="isExpanded"
    :openWidth="openWidth"
    :closedWidth="closedWidth"
    mode="width"
    class="file-details-panel file-details-panel__root"
    hideButton
  >
    <pui-flex class="file-details-panel__noItem" direction="column" alignItems="center">
      <pui-flex>
        <p class="file-details-panel__noItem-message">
          {{ $t('dam.files.panel_selection.no_items.selection_instruction') }}
        </p>
      </pui-flex>

      <template v-if="!!selectionFiles.length && !showSelectionPanel">
        <pui-flex>{{ $t('dam.files.panel_selection.no_items.or') }}</pui-flex>
        <pui-flex>{{ $t('dam.files.panel_selection.no_items.open_selection') }}</pui-flex>
      </template>
    </pui-flex>

    <pui-slide-panel
      :isOpen="showSelectionPanel"
      :showCloseButton="false"
      class="file-details-panel__info-slide-panel"
    >
      <pui-file-panel-selection
        ref="panelSelection"
        :isExpanded="isExpanded"
        :files="selectionFiles"
        :title="$t('dam.files.panel_selection.title.selection')"
        :showOpenSelectionDialog="!hideOpenSelectionDialog"
        :draggingFolder="draggingFolder"
        @toggleOpen="toggleMainExpansion"
        @openSelectionDialog="openSelectionDialog"
        class="file-details-panel__panel-selection"
        fileRequestNamespace="selection-files"
      />
    </pui-slide-panel>

    <pui-slide-panel
      :isOpen="showInfoPanel"
      :showCloseButton="false"
      class="file-details-panel__info-slide-panel"
    >
      <pui-file-panel-selection
        ref="panelInfo"
        :isExpanded="isExpanded"
        :files="infoFiles"
        :title="$t('dam.files.panel_selection.title.information')"
        :draggingFolder="draggingFolder"
        @toggleOpen="toggleMainExpansion"
        class="file-details-panel__panel-info"
        fileRequestNamespace="info-files"
      />
    </pui-slide-panel>
  </pui-side-panel>
</template>

<script>
import puiFilePanelSelection from './FilePanelSelection';

export default {
  components: {
    puiFilePanelSelection,
  },
  props: {
    /**
     * Selected information files
     */
    infoFiles: {
      type: Array,
      required: true,
    },
    /**
     * Selected files
     */
    selectionFiles: {
      type: Array,
      required: true,
    },
    /**
     * If this panel is opened
     */
    isExpanded: {
      type: Boolean,
      required: false,
    },
    /**
     * Panel opened width
     */
    openWidth: {
      type: String,
      required: true,
    },
    /**
     * Panel closed width
     */
    closedWidth: {
      type: String,
      required: true,
    },
    /**
     * If the selection panel should be visible
     */
    showSelectionPanel: {
      type: Boolean,
      required: false,
    },
    /**
     * If the info panel should be visible
     */
    showInfoPanel: {
      type: Boolean,
      required: false,
    },
    /**
     * If should hide the 'open' selection dialog button on selected files
     */
    hideOpenSelectionDialog: {
      type: Boolean,
      required: false,
    },
    /**
     * The folder being dragged
     */
    draggingFolder: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {};
  },
  methods: {
    // PANEL
    /**
     * Emits the 'closePanel' event
     *
     * @returns {void}
     */
    closePanel() {
      this.$emit('closePanel');
    },
    /**
     * Emits the 'toggleOpen' event
     *
     * @returns {void}
     */
    toggleMainExpansion() {
      this.$emit('toggleOpen');
    },
    // BOTH
    /**
     * Will show a confirmation dialog if there are dirty attributes
     * or something that prevents a save. On save/ignore, the callback will be invoked
     *
     * @param {() => void} actionCallback - the function to call after the user indicates to discard
     * the unsaved changes, or after the changes are saved, or if there is nothing to save at all
     * @param {string} panel - the panel on who to confirm the action
     */
    executeConfirmableAction(actionCallback, panel) {
      if (panel === 'selection') {
        this.$refs.panelSelection.executeConfirmableAction(actionCallback);
      } else if (panel === 'information') {
        this.$refs.panelInfo.executeConfirmableAction(actionCallback);
      }
    },
    // INFO
    /**
     * Updates the information form
     *
     * @returns {Promise<void>} the update promise
     */
    async refreshInformationForm() {
      // Wait for the information panel to receive new files via props
      await this.$nextTick();
      if (this.$refs.panelInfo) {
        return this.$refs.panelInfo.updateForm();
      }
    },
    // SELECTION
    /**
     * Re emits the 'openSelectionDialog' event
     *
     * @returns {void}
     */
    openSelectionDialog() {
      this.$emit('openSelectionDialog');
    },
    /**
     * Updates the selection form
     *
     * @returns {Promise<void>} the update promise
     */
    async refreshSelectionForm() {
      // Wait for the selection panel to receive new files via props
      await this.$nextTick();
      if (this.$refs.panelInfo) {
        return this.$refs.panelSelection.updateForm();
      }
    },
  },
};
</script>
